import error from './en-US/error';
import menu from './en-US/menu';
import pages from './en-US/pages';
import button from './en-US/button';
import placeholder from './en-US/placeholder';
import validmessage from './en-US/validmessage';
import tipmessage from './en-US/tipmessage';

const enUS = {
  'common.welcome': 'Welcome to',
  'common.loading': 'Loading...',
  'layout.appname': 'ABB EL China Digital Express Management System',
  'layout.lang': 'Languages',
  'layout.signout': 'Sign Out',
  'modal.title': 'System Message',
  'system.notice': 'Notice',
  'system.draftbox': 'My draft box',
  'system.nodata': 'No Data',
  'infiniteScroll.content.loading': 'Loading',
  'infiniteScroll.content.nomoredata': '--- No more data ---',
  'pullToRefresh.status.pulling': 'Pull to Refresh',
  'pullToRefresh.status.canRelease': 'Release and refresh immediately',
  'pullToRefresh.status.refreshing': 'Loading...',
  'pullToRefresh.status.complete': 'Refresh successful',
  ...error,
  ...menu,
  ...pages,
  ...button,
  ...placeholder,
  ...validmessage,
  ...tipmessage,
};
export default enUS;
